import * as R from 'ramda';
import { graphql } from 'react-relay';
import { fetchQuery } from 'relay-runtime';
import environment from '../graphql/Environment';

const QCheckEmailUnicity = graphql`
 query useCheckEmailUnicityQuery($values: EscAdminInput!) {
   checkEmailUnicity(values: $values)
 }
`;

const useCheckEmailUnicity = () => {
  return (values, callback) => {
    try {
      fetchQuery(environment, QCheckEmailUnicity, { values }).subscribe({
        next: data => {
          if (!R.isNil(callback) && R.is(Function, callback)) {
            callback(data.checkEmailUnicity);
          }
        },
        error: error => {
          console.error(error);
          callback(false);
        }
      });
    } catch (error) {
      console.error(error);
      callback(false);
    }
  };
};

export default useCheckEmailUnicity;
